import { render, staticRenderFns } from "./AdminMenuView.vue?vue&type=template&id=a36507f4&scoped=true&"
import script from "./AdminMenuView.vue?vue&type=script&lang=js&"
export * from "./AdminMenuView.vue?vue&type=script&lang=js&"
import style0 from "./AdminMenuView.vue?vue&type=style&index=0&id=a36507f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36507f4",
  null
  
)

export default component.exports